import React, { useEffect } from 'react';

import { Navigate, useParams } from 'react-router-dom';

import { fetchLegalEntity } from './api';
import { Form } from './components';
import { LegalEntityFormDispatch } from './context';
import { useActions } from './useActions';

const LegalEntityForm: React.FC = () => {
  const { legalEntityId } = useParams();
  const { state, dispatch, ...actions } = useActions();
  const { setLegalEntity, setLoadingLegalEntity } = actions;

  useEffect(() => {
    if (legalEntityId) {
      setLoadingLegalEntity(true);
      fetchLegalEntity(legalEntityId)
        .then((result) => {
          setLegalEntity(result);
        })
        .catch(() => {
          return <Navigate to="../../legal_entities" />;
        })
        .finally(() => {
          setLoadingLegalEntity(false);
        });
    }
  }, [dispatch, legalEntityId, setLegalEntity, setLoadingLegalEntity]);

  return (
    <LegalEntityFormDispatch.Provider value={{ state, dispatch, actions }}>
      <div className="sm:px-6 lg:px-8 flex flex-col h-full px-4 py-8 overflow-auto">
        <h2>Add/edit Legal Entity</h2>
        <Form />
      </div>
    </LegalEntityFormDispatch.Provider>
  );
};

export default LegalEntityForm;
